import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemDeprecateMode extends Cloneable {
    static DISABLED = new ItemDeprecateMode(0, "DISABLED");
    static DEFAULT = new ItemDeprecateMode(1, "DEFAULT");
    static GUARD = new ItemDeprecateMode(2, "GUARD");
    static REMOVED = new ItemDeprecateMode(3, "REMOVED");
    static LIFETIME = new ItemDeprecateMode(4, "LIFETIME");

    static _values = [
        this.DISABLED,
        this.DEFAULT,
        this.GUARD,
        this.REMOVED,
        this.LIFETIME
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemDeprecateMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemDeprecateMode) {
            return ItemDeprecateMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DISABLED") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemDeprecateMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemDeprecateMode());
        } else if (target instanceof ItemDeprecateMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemDeprecateMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});